// Dependencies imports
import React, { useState } from 'react';
import swal from 'sweetalert';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from "react-redux";
import CircularProgress from '@material-ui/core/CircularProgress';

// Local imports
import { Constants } from "../../config/constants";
import { authData } from "../../redux/auth/authSlice";
import { API } from "aws-amplify";
import config from "../../config/aws-exports";

// Styles imports
import Add from './AddEvent.module.scss';


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    heigth: "100%",
    alignItems: "center",
    justifyContent: "center",
    background: "transparent"
  },
}));

// Start of main delete user component
const DeleteUser = (props) => {
  let { handleCloseDelete, getFaculty , userData, mailUserList, setSelectionModel} = props;
  let userDetails = useSelector(authData);
  const [spin, setSpin] = useState(false);
  const classes = useStyles();


  async function onDelete() {
    setSpin(true);
    console.log("user data" + JSON.stringify(userData));
    console.log("user details" + JSON.stringify(userDetails))
    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        bpid: userDetails.curprgcou.bpid,
        userdata: mailUserList,
        action: "delete",
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
  
    try {
      console.log(JSON.stringify(bodyParam.body, null, 2));
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        `/assignUserToBatch`,
        bodyParam
      );
      console.log("response" + JSON.stringify(response)); 
      setSelectionModel([]);
      if (
        response == "Entered id is not a user" ||
        response == "User not found"
      ) {
        swal({
          title: "Error",
          text: response,
          icon: "error",
          dangerMode: false,
          closeOnClickOutside: false,
        }).then((willDelete) => {
          if (willDelete) {
            setSpin(false);
            handleCloseDelete();
            // handleUserClose();
            // getFaculty();
          }
        });
      } else {
        swal({
          title: "Success",
          text: "User Successfully removed from the batch",
          icon: "success",
          dangerMode: false,
          closeOnClickOutside: false,
        }).then((willDelete) => {
          if (willDelete) {
            setSpin(false);
            handleCloseDelete();
          }
        });
      }
      handleCloseDelete();
      setSpin(false);
      getFaculty();
    } catch (error) {
      console.error(error);
      swal({
        title: "Oooops!",
        text: "Soomthing wrong!",
        icon: "warning",
        dangerMode: true,
        closeOnClickOutside: false,
      }).then((willDelete) => {
        if (willDelete) {
          swal("Contact Developer");
          setSpin(false);
        }
      });
    }
  }

  return (
    <div>
      {spin === false ?
        <div className={Add.mainpopup}>
          {/* <h3 className={Add.header}>Delete Event</h3> */}
          <div className={Add.form}>
            <form>
              <div className={Add.header}>Are you sure you want to Remove?</div>
              {/* <input type="date" className={Add.date} onChange={onChangeHandlerEventDate} value={eventDate} /><br />
                    <div style={{color: "#cc0000", marginBottom: "12px", marginTop: "-10px", textAlign:"start", marginLeft: "20%"}}>{eventNameErr}</div>
                    <textarea placeholder="Type your event here..." rows={5} className={Add.area} onChange={onChangeHandlerEventName} value={evnentName} ></textarea>
                    <div className={Add.cautionholder}>
                        <h4 className={Add.caution}>* Event description should be less than 160 characters.</h4>
                    </div>
                    <input type="text" placeholder={"Add your link"} className={Add.date} onChange={onChangeHandlerEventLink} value={eventLink} ></input> */}
              <div className={Add.buttonholder}>
                <button className={window.navigator.onLine === true ? Add.btn_color : Add.btn_colordis } disabled={!window.navigator.onLine} onClick={() => {
                onDelete();
              }}>Yes</button>
                <button className={Add.cancel} onClick={handleCloseDelete}>NO</button>
              </div>
            </form>
          </div>
        </div> : <div className={classes.root}>
          <CircularProgress style={{ color: Constants.main_color_1 }} /></div>}
    </div>
  );
};

export default DeleteUser;